@if (loading) {
  <bt-spinner-overlay [opaque]="true"></bt-spinner-overlay>
}

<div [ngStyle]="{'height': 'calc(100vh - 84px)'}">
  <mat-card appearance="filled" fxFlex="100%">
    <mat-card-title fxLayout="row" fxLayoutAlign="start center">
      @if (organizationName) {
        <span class="header-text">{{organizationName}} D<small>&</small>A</span>
      }
    </mat-card-title>

    <mat-card-content fxLayout="column" fxFlex="100%" fxLayoutGap="10px">
      <div id="dashboard" class="dashboard-div"></div>
    </mat-card-content>
  </mat-card>
</div>
